import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICreditMap } from '@leedpulse-monorepo/interfaces';
import { ECreditAdjustmentReason } from '@leedpulse-monorepo/enums';

export interface SubscriptionCreditsAdjustmentResponse {
  subscription_id: string;
  credits: ICreditMap;
  balance_before: number;
  balance_after: number;
  cost_id: string;
}

async function addSubscriptionCredits(
  subscriptionId: string,
  amount: number,
  reason: ECreditAdjustmentReason,
  comment: string | null,
  auth: Authentication
): Promise<SubscriptionCreditsAdjustmentResponse> {
  try {
    const response = await HttpClient.post(
      `/backoffice/subscriptions/${subscriptionId}/credits/add`,
      { amount, reason, comment },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('addSubscriptionCredits error:', e);
    throw new AddSubscriptionCreditsFailure(e.message);
  }
}

export class AddSubscriptionCreditsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default addSubscriptionCredits;